import { apiClient } from '../_helpers';

export const collectionService = {
  getAll,
  getSelectList,
  getMyCollections,
  getById,
  searchCollections,
  addCollection,
  updateCollection,
  addRecipeToCollection,
  deleteCollection,
  removeRecipeFromCollection
};

async function getAll(params) {
  try {

    var ps = "";
    var ccat = "";
    if(params && params.query)
    {
      ps = ps + "searchTerm=" + params.query;
      ccat = "&";
    }
    if(params && params.filter)
    { 
      ps = ps + ccat + "filter=" + params.filter;
      ccat = "&";
    }
    if(params && params.pageSize)
    { 
      ps = ps + ccat + "pageSize=" + params.pageSize;
      ccat = "&";
    }
    if(params && params.page)
    {
      ps = ps + ccat + "pageNumber=" + params.page;
      ccat = "&";
    }
    if(params && params.dataTypes)
    {
      for (var i = 0; i < params.dataTypes.length; i++) { 
        ps = ps + ccat + "dataTypes=" + params.dataTypes[i];
        ccat = "&";
      }
    }

    const response = await apiClient(`collections?${ps}`)
      .get();
    return response.data;
  } catch (error) {
    return error;
  }
}

async function getSelectList() {
  try {
    const response = await apiClient('collections/selectlist')
      .get();
    return response.data;
  } catch (error) {
    return error;
  }
}

async function getMyCollections(params) {

  try {
    const response = await apiClient(`users/${params.userId}/mycollections`)
      .get();
    return response.data;
  } catch (error) {
    return error;
  }
}
async function getById(id) {
  try {
    const response = await apiClient('collections/')
      .get(`${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
}
async function searchCollections(qry) {
  try {
    const response = await apiClient(`collections?searchQuery=${qry}`)
      .get();
    return response.data;
  } catch (error) {
    return error;
  }
}
async function addCollection(newCollection) {
  try {
    const response = await apiClient('collections/')
      .post('', `${JSON.stringify(newCollection)}`);
    return response.data;
  } catch (error) {
    return error;
  }
}
async function updateCollection(newCollection) {
  try {
    const response = await apiClient(`collections/${newCollection.id}`)
      .put('', `${JSON.stringify(newCollection)}`);
    return response.data;
  } catch (error) {
    return error;
  }
}
async function deleteCollection(collection) {
  try {
    const response = await apiClient(`collections/${collection.collectionId}`)
      .delete();
    return response.data;
  } catch (error) {
    return error;
  }
}
async function addRecipeToCollection(payload) {
  try {
    const response = await apiClient(`collections/${payload.collectionId}/recipes/`)
      .post('', `${JSON.stringify(payload.recipe)}`);
    return response.data;
  } catch (error) {
    return error;
  }
}
async function removeRecipeFromCollection(payload) {
  try {
    const response = await apiClient(`collections/${payload.collectionId}/recipes/${payload.recipeId}`)
      .delete();
    return response.data;
  } catch (error) {
    return error;
  }
}